<template>
  <FormulateForm v-model="form" :errors="formErrors" :schema="schema" @submit="submitForm" />
</template>

<script>
import { NAME_VALIDATION } from '@/regex/name';

export default {
  props: {
    defaults: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      form: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        termsConsent: null,
        isNewsletterSubscriber: null,
      },
      formErrors: null,
    };
  },
  computed: {
    nameField() {
      return {
        name: 'name',
        type: 'text',
        label: 'Nombre',
        placeholder: 'Nombre',
        validation: ['required', ['matches', 'min:2', NAME_VALIDATION]],
        'validation-messages': {
          matches: 'Contiene carácteres incorrectos.',
          required: 'El nombre es obligatorio.',
          min: 'Introduce un nombre de al menos 2 letras.',
        },
      };
    },
    surnameField() {
      return {
        name: 'surname',
        type: 'text',
        label: 'Apellido',
        placeholder: 'Apellido',
        validation: ['required', ['matches', 'min:2', NAME_VALIDATION]],
        'validation-messages': {
          matches: 'Contiene carácteres incorrectos.',
          required: 'El nombre es obligatorio.',
          min: 'Introduce un apellido de al menos 2 letras.',
        },
      };
    },
    phoneField() {
      return {
        label: 'Teléfono',
        name: 'phone',
        type: 'phone',
        noExample: true,
        showCodeOnList: true,
        noFlags: true,
        borderRadius: 12,
        translations: {
          phoneNumberLabel: 'Introduce tu teléfono',
          countrySelectorLabel: 'código de país',
        },
        defaultCountryCode: 'ES',
        validation: 'required|phoneIsValid',
        'validation-messages': {
          required: 'El teléfono es obligatorio.',
          phoneIsValid: 'El número introducido es inválido.',
        },
      };
    },
    emailField() {
      return {
        component: 'div',
        class: 'formulate-input-wrapper-email',
        children: [
          {
            name: 'email',
            type: 'email',
            label: 'Email',
            validation: 'required|email',
            'validation-messages': {
              required: 'El mail es obligatorio.',
              email: 'El formato no es correcto.',
            },
          },
          {
            component: 'div',
            class: 'email-icon-wrapper',
            children: [
              {
                component: 'i',
                class: 'email-input-image',
              },
            ],
          },
        ],
      };
    },
    terms() {
      return {
        name: 'termsConsent',
        type: 'customCheckbox',
        validation: 'accepted',
        'validation-messages': {
          accepted: 'El campo es obligatorio.',
        },
        settings: {
          label: 'He leído y acepto la ',
          link: {
            href: 'https://trioteca.com/legal/politica-de-privacidad',
            text: 'Política de Privacidad.',
          },
          required: true,
        },
      };
    },
    inform() {
      return {
        name: 'isNewsletterSubscriber',
        type: 'customCheckbox',
        settings: {
          label: 'Acepto recibir comunicaciones con fines comerciales que puedan ser mi interés.',
        },
      };
    },
    submitButton() {
      return {
        type: 'submit',
        name: 'submit',
        label: 'Ver presupuesto',
      };
    },
    backButton() {
      return {
        component: 'a',
        class: 'popup__button',
        children: 'Volver',
        '@click': this.back,
      };
    },
    buttons() {
      return {
        component: 'div',
        class: 'popup__buttons',
        children: [this.backButton, this.submitButton],
      };
    },
    schema() {
      return [this.nameField, this.surnameField, this.emailField, this.phoneField, this.terms, this.inform, this.buttons];
    },
  },
  methods: {
    submitForm() {
      this.$emit('input', this.form);
      this.$emit('nextStep');
    },
    back() {
      this.$emit('prevStep');
    },
  },
  created() {
    if (this.defaults) {
      this.form = this.defaults;
    }
  },
};
</script>
